module.exports = {
          srcSet: __webpack_public_path__ + "public/images/0f40133f8367ae36ff79e6db42bd9e57-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/0f40133f8367ae36ff79e6db42bd9e57-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/0f40133f8367ae36ff79e6db42bd9e57-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/0f40133f8367ae36ff79e6db42bd9e57-1774.webp"},
          
          width: 1774,
          height: 887
        }